module.exports = __webpack_public_path__ + "static/coph1-3a5e59f70d5c8c62f1e0b7191313962a.jpg";